import Vue from 'vue'
import Router from 'vue-router'
import findpass from '@/module/findpass/FindPass'
import mycombo from '@/module/combo/mycombo'
import setpass from '@/module/findpass/SetPass'
import suc from '@/module/findpass/SetPassSuc'
import regpass from '@/module/register/RegPass'
import reg from '@/module/register/Reg'
import regprotocol from '@/module/register/RegProtocol'
import priprotocol from '@/module/register/PriProtocol'
import main from '@/module/index/Main'
// import bindMobile from '@/module/index/BindMobile'
import fcert from '@/module/user/Fcert'
import uploadFile from '@/module/sign/uploadFile'
import mySign from '@/module/user/mySign'
import refuse from '@/module/contract/Refuse'
import addsigner from '@/module/contract/AddSigner'
import savesigner from '@/module/contract/SaveSigner'
import sign from '@/module/contract/Sign'
import dsign from '@/module/contract/DSign'
import detail from '@/module/contract/Detail'
import dcontent from '@/module/contract/DContent'
import signature from '@/module/signature/Signature'
// import bindemail from '@/module/my/BindEmail'
import myinfo from '@/module/my/Myinfo'
import approval from '@/module/user/approval'
import bankApproval from '@/module/user/bankApproval'
import mycontact from '@/module/my/Mycontact'
import fromcontact from '@/module/my/Fromcontact'
import editpass from '@/module/my/EditPass'
import addMyContact from '@/module/my/AddMyContact'
import editMyContact from '@/module/my/EditMyContact'
import myAccount from '@/module/my/MyAccount'
import editSignCode from '@/module/my/EditSignCode'
import editemail from '@/module/my/EditEmail'
import buyCombo from '@/module/combo/BuyCombo'
import comboRecord from '@/module/combo/ComboRecord'
import imagetallor from '@/module/my/ImageTailor'
import createOrder from '@/module/combo/CreateOrder'
import payOldOrder from '@/module/combo/PayOldOrder'
import chooseApproval from '@/module/user/ChooseApproval'
import RealName from '@/module/realName/index.vue'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

var router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/main',
        },
        {
            path: '/findpass',
            name: 'findpass',
            component: findpass
        },
        {
            path: '/findpass/suc',
            name: 'suc',
            component: suc
        },
        {
            path: '/findpass/setpass',
            name: 'setpass',
            component: setpass
        },
        {
            path: '/reg/regpass',
            name: 'regpass',
            component: regpass
        },
        {
            path: '/reg',
            name: 'reg',
            component: reg
        },
        {
            path: '/reg/regprotocol',
            name: 'regprotocol',
            component: regprotocol
        },
        {
            path: '/reg/priprotocol',
            name: 'priprotocol',
            component: priprotocol
        },
        {
            path: '/combo/mycombo',
            name: 'mycombo',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: mycombo
        },
        {
            path: '/main',
            name: 'main',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: main
        },
        // {
        //     path: '/bindMobile',
        //     name: 'bindMobile',
        //     meta: {
        //         requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //     },
        //     component: bindMobile
        // },
        {
            path: '/user/fcert',
            name: 'fcert',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: fcert
        },
        {
            path: '/sign/uploadFile',
            name: 'uploadFile',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: uploadFile
        },
        {
            path: '/user/mySign',
            name: 'mySign',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: mySign
        },
        {
            path: '/contract/refuse',
            name: 'refuse',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: refuse
        },
        {
            path: '/contract/addsigner',
            name: 'addsigner',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: addsigner
        },
        {
            path: '/contract/savesigner',
            name: 'savesigner',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: savesigner
        },
        {
            path: '/contract/signature',
            name: 'signature',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: signature
        },
        {
            path: '/contract/sign',
            name: 'sign',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: sign
        },
        {
            path: '/contract/dsign',
            name: 'dsign',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: dsign
        },
        {
            path: '/contract/detail',
            name: 'detail',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: detail
        },
        {
            path: '/contract/detail/dcontent',
            name: 'dcontent',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: dcontent
        },
        // {
        //     path: '/my/bindemail',
        //     name: 'bindemail',
        //     meta: {
        //         requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //     },
        //     component: bindemail
        // },
        {
            path: '/my/myinfo',
            name: 'myinfo',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: myinfo
        },
        {
            path: '/user/approval',
            name: 'approval',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: approval
        },
        {
            path: '/user/bankApproval',
            name: 'bankApproval',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: bankApproval
        },
        {
            path: '/my/mycontact',
            name: 'mycontact',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: mycontact
        },
        {
            path: '/contract/fromcontact',
            name: 'fromcontact',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: fromcontact
        },
        {
            path: '/my/editpass',
            name: 'editpass',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: editpass
        },
        {
            path: '/my/mycontact/addMyContact',
            name: 'addMyContact',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: addMyContact
        },
        {
            path: '/my/mycontact/editMyContact',
            name: 'editMyContact',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: editMyContact
        },
        {
            path: '/my/myAccount',
            name: 'myAccount',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: myAccount
        },
        {
            path: '/my/editSignCode',
            name: 'editSignCode',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: editSignCode
        },
        {
            path: '/my/editemail:mail',
            name: 'editemail',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: editemail
        },
        {
            path: '/combo/buyCombo',
            name: 'buyCombo',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: buyCombo
        },
        {
            path: '/combo/comboRecord',
            name: 'comboRecord',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: comboRecord
        },
        {
            path: '/my/imagetallor',
            name: 'imagetallor',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: imagetallor
        },
        {
            path: '/combo/createOrder',
            name: 'createOrder',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: createOrder
        },
        {
            path: '/combo/payOldOrder',
            name: 'payOldOrder',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: payOldOrder
        },
        {
            path: '/user/chooseApproval',
            name: 'chooseApproval',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: chooseApproval
        },
        {
            path: '/realName',
            name: 'realName',
            meta: {
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            },
            component: RealName
        },
    ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js